import Vue from 'vue'
import Dexie from 'dexie'

const db = new Dexie('atlastories')

db.version(1).stores({
  gtu: 'version, date, text',
  images: 'url, ts, blob',
  tiles: 'xyz, ts, blob',
  markers: '_id, ts, hash, lang'
})

db.images.defineClass({
  url: String,
  ts: Number,
  blob: Blob
})

db.tiles.defineClass({
  xyz: String,
  ts: Number,
  blob: Blob
})

Vue.prototype.$db = db
